import { openInventoryPhotoPickerWithWebcam } from "./InventoryPhotoPicker";
import { Inventory, InventoryImage } from "types/inventory";

export default function openInventoryPhotoPicker(
  inventory: Inventory,
  onInventoryImageAdded: (inventoryImage: InventoryImage) => void,
) {
  return openInventoryPhotoPickerWithWebcam(inventory, onInventoryImageAdded);
}
